<template>
  <div style="margin: 15px;">
    <el-container class="main">
      <el-header class="homeHeader">
        <div class="homeTitle">西南交通大学网络教育学院毕业设计管理信息系统</div>
        <div>
          <!--          <el-button icon="el-icon-bell" type="text" style="margin-right: 8px;color: #000000;" size="normal"
                               @click="goChat"></el-button>
          -->
          <el-dropdown class="userInfo" @command="commandHandler">
            <span class="el-dropdown-link">{{ user.username }}
              <span v-show="topRole==='Administrator'">（超级管理员）</span>
              <span v-show="topRole==='Manager'">（运维人员）</span>
              <span v-show="topRole==='Admin'">（系统管理员）</span>
              <span v-show="topRole==='EducationDepartmentAdmin'">（教育厅管理员）</span>
              <span v-show="topRole==='UniversityAdmin'">（高校管理员）</span>
              <span v-show="topRole==='TeachingCenterAdmin'">（教学站点管理员）</span>
              <i class="fa fa-user-circle-o fa-lg" alt=""></i></span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="userinfo">个人中心</el-dropdown-item>
              <el-dropdown-item command="setting">设置</el-dropdown-item>
              <el-dropdown-item command="logout" divided>注销登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!--<i class="fa fa-bell-o fa-lg" aria-hidden="true"></i>-->
        </div>
      </el-header>
      <el-container>
        <el-aside width="200px">
          <el-menu router unique-opened :default-active="this.$router.path" class="aside" active-text-color="#429DF1">
            <template v-for="(item,index) in routes">
              <template v-if="item.children && item.children.length>0 && !item.hidden">
                <el-submenu :index="index.toString()" :key="index">
                  <template slot="title">
                    <i style="color: #429df1;margin-right: 10px" :class="item.iconCls"></i>
                    <span>{{ item.name }}</span>
                  </template>
                  <el-menu-item style="text-align: left;padding-left: 45px" :index="child.path"
                                v-for="(child,indexj) in item.children" :key="index+'-'+indexj">
                    {{ child.name }}
                  </el-menu-item>
                </el-submenu>
              </template>
              <template v-else-if="(!item.children || item.children.length==0) && !item.hidden">
                <el-menu-item style="text-align: left;padding-left: 45px" :index="item.path" :key="index"
                              @click="$router.push(item.path);">
                  <template slot="title">
                    <i style="color: #429df1;margin-right: 10px" :class="item.iconCls"></i>
                    <span>{{ item.name }}</span>
                  </template>
                </el-menu-item>
              </template>
            </template>
          </el-menu>
        </el-aside>
        <el-main>
          <el-breadcrumb separator-class="el-icon-arrow-right" v-if="this.$router.currentRoute.path!='/Home'">
            <el-breadcrumb-item :to="{ path: '/Home' }" class="title-name">首页</el-breadcrumb-item>
            <el-breadcrumb-item class="breadcrumb title-name-div">{{
                this.$router.currentRoute.name
              }}
            </el-breadcrumb-item>
          </el-breadcrumb>

          <div class="homeWelcome" v-if="this.$router.currentRoute.path=='/Home'">
            欢迎来到西南交通大学网络教育学院毕业设计管理信息系统！

          </div>
          <router-view class="homeRouterView"/>
        </el-main>
      </el-container>
      <div class="copyright-footer">主办单位：西南交通大学网络教育学院&nbsp;&nbsp;&nbsp;&nbsp;版权所有：西南交通大学网络教育学院毕业设计管理信息系统</div>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      // user: JSON.parse(window.sessionStorage.getItem("user"))
    }
  },
  computed: {
    routes() {
      return this.$store.state.routes;
    },
    user() {
      return this.$store.state.currentUser;
    },
    topRole() {
      return this.$store.state.topRole;
    },
    visibleR() {
      return this.topRole === 'Administrator' || this.topRole === 'Manager' || this.topRole === 'Admin' || this.topRole === 'EducationDepartmentAdmin';
    }
  },
  mounted() {
    this.initData();
  },
  watch: {
    '$route': {
      handler(route) {
        const me = this;
        if (route.name === 'Home') {
          me.initData();
        }
      },
      deep: true
    }
  },
  methods: {
    commandHandler(cmd) {
      if (cmd == 'logout') {
        this.$confirm('此操作将注销登录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.getRequest(this.$store.state.basePath + "/logout");
          window.sessionStorage.removeItem("currentUser")
          this.$store.commit('initRoutes', []);
          this.$router.replace("/");
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      } else if (cmd == 'userinfo') {
        // this.$router.push('/hrinfo');
      }
    },
    initData() {
      // this.drawWorkbench();
    }
  }
}
</script>

<style>
.homeRouterView {
  margin-top: 10px;
}

.main {
  width: 100%;
  height: 100%;
}

.el-main {
  padding: 0;
  background-color: #eeeeee;
}

.el-breadcrumb {
  height: 38px;
  padding-left: 20px;
  /*margin: 0 15px;*/
  background-color: #fff;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, .12) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12) !important;
}

.title-name {
  /*width: 80px;*/
  height: 24px;
  line-height: 25px;
  margin: 8px 0;
  /* border: 1px solid #cccccc; */
  border-radius: 5px;
}

.title-name-div {
  /*width: 100px;*/
  height: 26px;
  line-height: 26px;
  margin: 8px 0;
  /*background: #429df1;*/
  border-radius: 5px;
  /* color: #ffffff !important; */
}

.el-breadcrumb__item:last-child .el-breadcrumb__inner {
  color: #000;
}

.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  color: #000;
}

.el-breadcrumb__inner a,
.el-breadcrumb__inner.is-link {
  color: #000;
}

/*.homeWelcome {
  text-align: center;
  font-size: 30px;
  font-family: PingFang SC;
  color: #409eff;
  padding-top: 50px;
}*/

el-container {
  height: 100%;
  /*background-color: #374254;*/
}

/*.el-menu {
  border-right: none;
}
*/

.el-menu {
  border-right: 1px solid #e6e6e6;
  list-style: none;
  position: relative;
  margin: 0;
  padding-left: 0;
  border: none;
}

.el-menu-item {
  background-color: #374254 !important;
  color: #cccccc !important;
}

.el-submenu__title:hover {
  background-color: #374254 !important;
}

.el-submenu .el-menu-item:hover {
  color: #429DF1 !important;
  background-color: #374254 !important;
}

.el-menu-item.is-active {
  color: #409eff !important;
}

/* 修改左侧树菜单靠左 */
.el-submenu__title {
  /*color: #879dc1 !important;*/
  color: #cccccc !important;
  margin-left: -60px !important;
}

/* 修改左侧树菜单靠左 */
.el-submenu__icon-arrow {
  position: absolute;
  top: 55%;
  right: 50px;
}

.homeHeader {
  background-color: #424d5f;
  display: flex;
  align-items: center;
  border-bottom: 2px solid #353e4f;
  justify-content: space-between;
  padding: 0px 15px;
  box-sizing: border-box;
}

.homeHeader .homeTitle {
  font-size: 18px;
  font-family: PingFang SC;
  color: #ffffff;
}

.homeHeader .userInfo {
  cursor: pointer;
}

.aside {
  /*height: 1024px;*/
  background-color: #424d5f !important;
  color: #999;
}

.aside.el-menu {
  min-height: 800px !important;
}

.el-dropdown-link i {
  margin-left: 5px;
}

.el-dropdown-link {
  display: flex;
  align-items: center;
  color: white;
}

.homeHeader div i {
  margin-left: 5px;
  cursor: pointer;
  color: white;
}

.home {
  width: 100%;
  height: 100%;
}

.home .homeTitle {
  font-size: 28px;
  line-height: 28px;
  color: #202020;
  width: 100%;
  height: 166px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
}

.home .content {
  width: 100%;
  /*height: 750px;*/
  height: 100%;
  background-color: #f6f7f9;
  display: flex;
  justify-content: center;
  /*align-items: center;*/
}

.home .content .left,
.home .content .right {
  width: 350px;
  height: 229px;
  /*height: 338px;*/
  background-color: #fff;
}

.home .content .left {
  /*margin-right: 30px;*/
  margin: 30px 30px 30px 30px;
  position: relative;
}

.home .content .left .title {
  width: 100%;
  height: 60px;
  background-color: #3372be;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 22px;
}

.home .content .left .title span {
  font-size: 28px;
  font-style: italic;
}

.home .content .left .time {
  width: 100%;
  height: 40px;
  background-color: #90b0d7;
  color: #103fafc;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.home .content .msgSure {
  width: 100%;
  height: 69px;
  border-bottom: 1px solid #e1e1e1;
  display: flex;
  align-items: center;
  background-color: #fafafa;
  padding-left: 28px;
  box-sizing: border-box;
}

.home .content .msgSure .qrIcon {
  width: 23px;
  height: 23px;
  margin-right: 24px;
}

.home .content .msgSure .txt {
  font-size: 16px;
  color: #595959;
}

.home .content .ykbIcon {
  position: absolute;
  bottom: 5px;
  right: 5px;
}

.home .content .right {
  /*margin-right: 30px;*/
  margin: 30px 30px 30px 0;
  position: relative;
}

.home .content .right .title {
  width: 100%;
  height: 60px;
  background-color: #23a0c2;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 22px;
}

.home .content .right .title span {
  font-size: 28px;
  font-style: italic;
}

.home .content .right .time {
  width: 100%;
  height: 40px;
  background-color: #7ac2d6;
  color: #103fafc;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.home .content .msgTx {
  width: 100%;
  height: 69px;
  border-bottom: 1px solid #e1e1e1;
  display: flex;
  align-items: center;
  background-color: #fafafa;
  padding-left: 28px;
  box-sizing: border-box;
}

.home .content .msgTx .qrIcon {
  width: 23px;
  height: 23px;
  margin-right: 24px;
}

.home .content .msgTx .txt {
  font-size: 16px;
  color: #595959;
}

.home .content .msgBs {
  width: 100%;
  height: 69px;
  border-bottom: 1px solid #e1e1e1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  padding: 0 28px;
  box-sizing: border-box;
}

.home .content .msgBs .msgBsleft {
  display: flex;
  align-items: center;
}

.home .content .msgBs .msgBsleft .qrIcon {
  width: 23px;
  height: 23px;
  margin-right: 24px;
}

.home .content .msgBs .msgBsleft .txt {
  font-size: 16px;
  color: #595959;
}

.home .content .msgBs .msgBsright .bsBtn {
  width: 80px;
  height: 38px;
  background-color: #eb5444;
  font-size: 14px;
  color: #fff;
  border: none;
  border-radius: 4px;
}

/*管理员工作台*/
.manage {
  width: 100%;
  height: 100%;
  /*padding-bottom: 166px;*/
}

.manage .title {
  font-size: 28px;
  line-height: 28px;
  color: #202020;
  width: 100%;
  height: 86px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
}

.manage .content {
  width: 100%;
  /*height: 748px;*/
  height: 100%;
  /*margin: 0 auto;*/
  display: flex;
  justify-content: start;
  margin-top: 1px;
  flex-direction: column;
}

.manage .content .oneTitle,
.manage .content .twoTitle {
  height: 58px;
  width: 100%;
  color: #fff;
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.manage .content .oneTitle {
  background-color: #3372be;
}

.manage .content .twoTitle {
  background-color: #23a0c2;
}

.manage .content .contentOne {
  height: 440px;
  width: 100%;
  background-color: #f6f7f9;
}

.manage .content .contentOne #charts {
  width: 400px;
  height: 400px;
}

.manage .content .line {
  height: 20px;
  width: 100%;
  background-color: #fff;
}

.manage .content .contentTwo {
  width: 100%;
  height: 172px;
  background-color: #f6f7f9;
  display: flex;
  align-items: center;
}

.manage .content .contentTwo .shuxian {
  height: 60px;
  width: 1px;
  background-color: #dddee0;
}

.manage .content .contentTwo .gxBox,
.manage .content .contentTwo .jxzdBox,
.manage .content .contentTwo .zjzcBox {
  width: 33%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.manage .content .contentTwo .gxBox .ctTitle,
.manage .content .contentTwo .jxzdBox .ctTitle,
.manage .content .contentTwo .zjzcBox .ctTitle {
  font-size: 16px;
  color: #0f0f0f;
  margin-bottom: 28px;
}

.manage .content .contentTwo .gxBox .numBox,
.manage .content .contentTwo .jxzdBox .numBox,
.manage .content .contentTwo .zjzcBox .numBox {
  display: flex;
  align-items: flex-end;
}

.manage .content .contentTwo .gxBox .numBox .gxsl,
.manage .content .contentTwo .jxzdBox .numBox .gxsl,
.manage .content .contentTwo .zjzcBox .numBox .gxsl {
  font-size: 23px;
  color: #5765c6;
}

.manage .content .contentTwo .gxBox .numBox .zdsl,
.manage .content .contentTwo .jxzdBox .numBox .zdsl,
.manage .content .contentTwo .zjzcBox .numBox .zdsl {
  font-size: 23px;
  color: #fe6555;
}

.manage .content .contentTwo .gxBox .numBox .zcsl,
.manage .content .contentTwo .jxzdBox .numBox .zcsl,
.manage .content .contentTwo .zjzcBox .numBox .zcsl {
  font-size: 23px;
  color: #00bdda;
}

.manage .content .contentTwo .gxBox .numBox .dw,
.manage .content .contentTwo .jxzdBox .numBox .dw,
.manage .content .contentTwo .zjzcBox .numBox .dw {
  font-size: 12px;
  color: #b3b4b5;
}

.copyright-footer {
  background-color: white;
  color: black;
  text-align: center;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
}

</style>



// WEBPACK FOOTER //
// src/views/Home.vue